export default "__VITE_ASSET__CDvWyMgl__"